import { render, staticRenderFns } from "./TeaserImage.vue?vue&type=template&id=a3550b2e&"
import script from "./TeaserImage.vue?vue&type=script&lang=ts&"
export * from "./TeaserImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports